import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { GradientLoader } from "./commonComponents";

export function PublicRoute(props) {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return <GradientLoader/>;
  }

  if (isAuthenticated) {
    return <Navigate to="/" />;
  }

  return <>{props.children}</>;
}

export default PublicRoute;